class ModalWindow extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.debug = false;
    if (this.debug) console.log('ModalWindow constructor');
  }

  connectedCallback() {
    if (this.debug) console.log('ModalWindow connected callback');
    this.attachModalListeners();
  }

  attachModalListeners() {
    const close_element = this.querySelector('.close');

    // Remove existing listeners to prevent duplicates
    if (this.boundHandleClick) {
      document.removeEventListener('click', this.boundHandleClick);
    }
    if (this.boundHandleKeydown) {
      document.removeEventListener('keydown', this.boundHandleKeydown);
    }

    this.boundHandleClick = this.handleTriggerClick.bind(this);
    this.boundHandleKeydown = this.handleKeydown.bind(this);

    // Use event delegation on document for better performance and dynamic content support
    document.addEventListener('click', this.boundHandleClick);
    document.addEventListener('keydown', this.boundHandleKeydown);

    // When the user clicks anywhere outside of the modal, close it
    this.addEventListener('click', (event) => {
      if (event.target === this) {
        this.hide();
      }
    });

    if (close_element) {
      close_element.addEventListener('click', () => {
        this.hide();
      });
    }
  }

  handleTriggerClick(event) {
    const modalTrigger = event.target.closest(`[data-open-modal="#${this.id}"]`);
    if (modalTrigger) {
      event.preventDefault();
      this.show(modalTrigger);
    }
  }

  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      const modalTrigger = event.target.closest(`[data-open-modal="#${this.id}"]`);
      if (modalTrigger) {
        event.preventDefault();
        this.show(modalTrigger);
      }
    } else if (event.key === 'Escape') {
      // Close this modal if it's currently visible
      if (this.classList.contains('modal-show')) {
        event.preventDefault();
        this.hide();
      }
    }
  }

  disconnectedCallback() {
    // Clean up event listeners when modal is removed from DOM
    if (this.boundHandleClick) {
      document.removeEventListener('click', this.boundHandleClick);
    }
    if (this.boundHandleKeydown) {
      document.removeEventListener('keydown', this.boundHandleKeydown);
    }
  }

  show(modalTrigger) {
    const modalId = modalTrigger.getAttribute('data-open-modal');
    // find the element by ID
    const modalElement = document.querySelector(modalId);
    if (modalElement) {
      if (modalElement.classList.contains('modal-show')) {
        modalElement.classList.remove('modal-visuallyshow');
        setTimeout(function () {
          modalElement.classList.remove('modal-show');
        }, 2000);
      } else {
        modalElement.classList.add('modal-show');
        setTimeout(() => {
          modalElement.classList.add('modal-visuallyshow');
        }, 1);
      }
      modalElement.style.display = 'block';
      // add overflow hidden to body
      document.body.style.overflow = 'hidden';
      // fire custom event of a modal window opening
      document.dispatchEvent(new CustomEvent('modal-window-opened'));

      this.opener = modalTrigger;

      requestAnimationFrame(() => {
        trapFocus(this);
      });
    }
  }

  hide() {
    // Store opener reference before removing trap focus
    const opener = this.opener;
    const isInsideDrawer = opener && opener.closest('header-drawer');

    removeTrapFocus(this.opener);
    this.style.display = 'none';
    this.classList.remove('modal-visuallyshow');
    this.classList.remove('modal-show');

    // Restore body overflow — if opened from within a drawer,
    // keep overflow hidden so the drawer stays scrollable
    if (isInsideDrawer) {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'auto';
    }

    // send a custom event of a modal window closing
    document.dispatchEvent(new CustomEvent('modal-window-closed'));
  }
}

customElements.define('modal-window', ModalWindow);
